import Highlight from '@tiptap/extension-highlight';

const PulseHighlight = Highlight.extend({
  addAttributes() {
    return {
      ...this.parent?.(), // keep "color" when multicolor=true
      class: {
        default: null,
        parseHTML: (el) => el.getAttribute('class'),
        renderHTML: (attrs) => (attrs.class ? { class: attrs.class } : {}),
      },
    };
  },
});

export default PulseHighlight;
